export default {
  standardOpeningHours: state => state.standardOpeningHours,
  holidayOpeningHours: state => state.holidayOpeningHours,
  tenantDetails: state => state.tenantDetails,
  selectedTenant: state => state.selectedTenant,
  totalLogEntries: state => state.totalLogEntries,
  outOfHoursAuditLog: state => state.outOfHoursAuditLog,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  pageSize: state => state.pageSize
}



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/getters.js